import { Pencil, Plus, X } from "lucide-react";

export const AccountsBar = ({ group, accounts, onAdd, onEdit, onDelete }) => (
  <div data-testid={`accounts-bar-${group.id}`} className="px-4 py-3 border-b flex flex-wrap items-center gap-2">
    <span className="text-xs uppercase tracking-wider text-slate-500 mr-1">Sites</span>
    {accounts.length === 0 && <span className="text-xs text-slate-400">No sites yet. Add site name and user ID once.</span>}
    {accounts.map((a) => (
      <span key={a.id} data-testid={`account-chip-${a.id}`} className="group inline-flex items-center gap-1.5 border rounded-full pl-3 pr-1 py-0.5 text-xs bg-white">
        {a.site_name} <span className="font-mono text-slate-500">{a.user_code}</span>
        <button data-testid={`account-edit-${a.id}`} onClick={() => onEdit(a)} className="p-0.5 rounded-full text-slate-400 hover:text-slate-900"><Pencil className="w-3 h-3" /></button>
        <button data-testid={`account-delete-${a.id}`} onClick={() => onDelete(a)} className="p-0.5 rounded-full text-slate-400 hover:text-red-600"><X className="w-3 h-3" /></button>
      </span>
    ))}
    <button data-testid={`account-add-${group.id}`} onClick={onAdd}
      className="inline-flex items-center gap-1 rounded-full border border-dashed px-3 py-0.5 text-xs text-sky-700 hover:bg-sky-50 transition-colors">
      <Plus className="w-3 h-3" /> Add site
    </button>
  </div>
);
